<div class="add-widget-dialog__wrapper">
    <em class="add-widget-dialog__close fas fa-times fa-1_5x text-danger cursor-pointer" (click)="closeDialog()"></em>

    <h2 class="text-center mt-2 mb-5 fw-normal">{{ 'Widget hinzufügen' | translate }}</h2>

    <div class="add-widget-dialog">
        <div class="add-widget-dialog__categories">
            <ul class="add-widget-dialog__list mb-0">
                @for (category of availableCategories; track $index) {
                    <li
                        (click)="selectItem(category)"
                        class="add-widget-dialog__list-item cursor-pointer"
                        [ngClass]="{ active: category === categoryWidgetType }"
                    >
                        {{ WidgetCategoryNames[category] | translate }}
                    </li>
                }
            </ul>
        </div>

        <div class="add-widget-dialog__widgets">
            <div class="add-widget-dialog__preview">
                @for (container of data.widgets; track $index) {
                    @if (categoryWidgetType === container.category) {
                        <iim-card [footer]="footer">
                            <ng-container *ngComponentOutlet="container.component; injector: injector"></ng-container>

                            <ng-template #footer>
                                <div class="d-flex justify-content-end">
                                    @if (!isContainerInNewArray(container)) {
                                        <button class="btn btn-success" (click)="addWidgetToList(container.id)">
                                            <em class="fas fa-plus pe-1"></em>
                                            <span>{{ 'hinzufügen' | translate }}</span>
                                        </button>
                                    }
                                    @if (isContainerInNewArray(container)) {
                                        <button class="btn btn-danger" (click)="removeWidgetFromList(container.id)">
                                            <em class="fas fa-minus pe-1"></em>
                                            <span>{{ 'vom Dashboard entfernen' | translate }}</span>
                                        </button>
                                    }
                                </div>
                            </ng-template>
                        </iim-card>
                    }
                }
            </div>
        </div>
    </div>
</div>
